import { useFormik } from "formik";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { jobService } from "services";
import * as Yup from "yup";

function FiltersPop(props) {
  const { show, handleClose, setData } = props;

  const [isLoading, setIsLoading] = useState(false);


  const yearList = [];
  for (let year = 2015; year <= new Date().getFullYear(); year++) {
    yearList.push(year);
  }
  yearList.reverse();

  const formik = useFormik({
    initialValues: {
      year: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      year: Yup.string().required("Please Select Year"),
    }),
    onSubmit: async (values) => {
      const selectedYear = parseInt(values.year);
      try {
        const response = await jobService.yearFilter(selectedYear);
        setData(response?.data?.data)
        if (response?.data?.data?.totalJobs === 0) {
          toast.error("No jobs exist")
        }
        handleClose()
      } catch (err) {
        console.error(err?.response?.data?.message);
      }
    },
  });

  return (
    <>
      <Modal show={show} className="modal-common" onHide={handleClose}>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <p className="mb-0">Filters</p>
          <p className=" mb-0 fw-normal cursor-pointer text-white" onClick={formik.resetForm}>Reset</p>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit} id="filtersForm">
            <div className="">
              <div className="form-control-bg">
              <select
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.year}
                name="year"
                className="form-select"
                aria-label="Yearly select"
              >
                <option value="">Select Year</option>
                {yearList.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              </div>
              {formik.touched.year && formik.errors.year ? (
                <span className="text-danger">{formik.errors.year}</span>
              ) : null}
            </div>

            
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="submit"
            form="filtersForm"
            className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
            disabled={isLoading}
          >
            Apply
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FiltersPop;
